import PropTypes from 'prop-types';
import React from 'react';
import { usePagination, DOTS } from '../../hooks/usePagination';
import { LeftArrow, RightArrow, HorizontalDots } from '../Svg/Svg';

export default function Pagination({ data, controlls }) {
    const {
        current_page: currentPage,
        total: totalCount,
        per_page: pageSize,
    } = data;
    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount: 1,
        pageSize,
    });

    const onNextClick = () => {
        const page = data.current_page + 1;

        controlls.nextClick(page);
    };

    const onPreviousClick = () => {
        const page = data.current_page - 1;

        controlls.previousClick(page);
    };

    const onPageChange = (pageNumber) => {
        controlls.pageChange(pageNumber);
    };

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    return (
        <div className="pagination__wrapper">
            <ul className="pagination__list">
                <li key="prev" className="pagination__item">
                    <button
                        onClick={onPreviousClick}
                        disabled={data.current_page === 1}
                        className={`pagination__button ${
                            data.current_page === 1 &&
                            'pagination__button--disabled'
                        }`}
                    >
                        <LeftArrow />
                    </button>
                </li>
                {paginationRange.map((pageNumber, i) => {
                    if (pageNumber === DOTS) {
                        return (
                            <li key={i} className="pagination__item--dots">
                                <HorizontalDots />
                            </li>
                        );
                    }

                    return (
                        <li key={i} className="pagination__item">
                            <button
                                onClick={() => onPageChange(pageNumber)}
                                className={`pagination__button ${
                                    data.current_page === pageNumber &&
                                    'pagination__button--active'
                                }`}
                            >
                                {pageNumber}
                            </button>
                        </li>
                    );
                })}
                <li key="next" className="pagination_item">
                    <button
                        onClick={onNextClick}
                        disabled={data.current_page === data.last_page}
                        className={`pagination__button ${
                            data.current_page === data.last_page &&
                            'pagination__button--disabled'
                        }`}
                    >
                        <RightArrow />
                    </button>
                </li>
            </ul>
        </div>
    );
}

Pagination.propTypes = {
    /* Meta data  */
    data: PropTypes.object,
    /* Navigation controlls */
    controlls: PropTypes.objectOf(PropTypes.func),
};
